import { remask, unRemask } from "../../../libs/remask-mask";
import { TimeWorkClosed, UserProjectTimeWork } from "../model";

function filterById(filterList: any, label: any, field: string) {
  let id = 0;
  filterList?.forEach((element: any) => {
    if (element[field]?.toLowerCase() === label?.toLowerCase()) id = element.id;
  });
  return id;
}

function filterIsChecked(initialValue: any[]) {
 return initialValue?.filter((element: any) => Boolean(element.checked));
}

function isTimeApproved(formData: any) {
  let count = 0;
  formData?.forEach((item: any) => {
    if (!item.timeApproved) count++;
  });
  return Boolean(count);
}

function generatorObjTimeWorkClosed(newInitialValue: UserProjectTimeWork[], splitFormartDate: any) {
  const formData: UserProjectTimeWork[] = newInitialValue?.map((data) => {
    const dataWork: UserProjectTimeWork = {
      userId: data.userId,
      projectId: data.projectId,
      workedTime: data.workedTime,
    };
    return dataWork;
  });
  const data: TimeWorkClosed = {
    month: Number(splitFormartDate[1]),
    year: Number(splitFormartDate[0]),
    userProjectsTimeWork: formData,
  };
  return data;
}

function orderByFieldGeneration(orderByField: any[]) {
  const array = orderByField?.map((item) => item.field);
  return array;
}

function orderByFieldEditableGeneration(orderByField: any[]) {
  const array = orderByField?.map((item) => item.editable && item.field);
  return array;
}

function objectGenerator(element: any) {
  const obj = {
    ...element,
    checked: !element.checked,
  };
  return obj;
}

function isCheckdAll(element: any, value: boolean) {
  const obj = {
    ...element,
    checked: value,
  };
  return obj;
}

function objectGeneratorApprovalHours(listCheckbox: any[], id: number, inputValue: any) {
  const newList = listCheckbox?.map((item: any) => {
    if (Number(item.id) !== Number(id)) return item;
    const data = {
      ...item,
      timeApproved: inputValue,
    };
    return data;
  });
  return newList;
}

//input 50 => output 50:00:00
function completeValueBlur(value: any) {
  let clearValue = String(unRemask(value));
  if (clearValue?.length === 1) clearValue += "00000";
  if (clearValue?.length === 2) clearValue += "0000";
  if (clearValue?.length === 3) clearValue += "0000";
  if (clearValue?.length === 4) clearValue += "00";
  if (clearValue?.length === 5) clearValue += "00";
  return remask(clearValue, ["SS:SS:SS", "SSS:SS:SS"]);
}

export {
  isTimeApproved,
  orderByFieldGeneration,
  orderByFieldEditableGeneration,
  filterIsChecked,
  filterById,
  generatorObjTimeWorkClosed,
  objectGenerator,
  isCheckdAll,
  completeValueBlur,
  objectGeneratorApprovalHours,
};
